export default __webpack_public_path__ + "static/media/4.88be8a51.jpeg";